import type { PageData } from "../../src/types/pageData";
export async function getPageInfo(params: Record<string, any>) {
  const { GET } = useRequest();
  const { locale } = useI18n();
  try {
    const data = await GET<PageData>("/SiteWeb/PageData/GetPageInfo", {
      PageID: "ddc3d0512231465e859eecd48295dc43",
      lang: unref(locale),
      ...params,
    });
    return (data as PageData)?.areaData ? data : { areaData: [] };
  } catch {
    return { areaData: [] };
  }
}
